import { styled } from 'ps-gui';

export const ModuleHeader = styled.div`
	padding: 8px 0px;
	font-size: 24px;
	font-weight: 700;
	color: ${props => props.theme.disabledTextColor};
`;

export const ModuleHeaderBlock = styled.div`
	padding: 0px 8px 20px 8px;
	&:first-child {
		padding-left: 21px;
	}
	&:last-child {
		padding-right: 21px;
	}
`;

export const ModuleHeaderSection = styled.div`
	&:not(.noBorder) {
		border-bottom: 1px solid #C6DAE7;
	}
	display: flex;
	${ModuleHeaderBlock}:first-child {
		flex-grow: 1;
	}
`;

export const ModuleBodySection = styled.div`
	padding: 20px 21px;
	position: relative;
	top: ${props => props.top};
`;
